/**
 * GuestLayout - Layout для гостевых страниц
 */

import React, { useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../contexts/AuthContext/AuthProvider";
import GuestMenu from "../menus/GuestMenu";

const GuestLayout = ({ children, showHeader = true, showFooter = true }) => {
    const { isAuthenticated } = useAuthContext();
    const navigate = useNavigate();
    const [openBurgerFn, setOpenBurgerFn] = useState(null);

    // стабильный колбэк для передачи в модал — предотвращает перезапуск эффекта
    const handleSetOpenBurger = useCallback((openFn) => {
        setOpenBurgerFn(() => openFn);
    }, []);

    const handleLoginClick = () => {
        navigate("/login");
    };

    return (
        <div className="app-container">
            <div className="main-container main-container--quest">
                {showHeader && (
                    <header className="header">
                        <div>
                            <button
                                className="burger-button"
                                onClick={() => openBurgerFn && openBurgerFn()}
                                aria-label="Меню"
                            >
                                <div></div>
                            </button>
                            <GuestMenu onTrigger={handleSetOpenBurger} />
                        </div>

                        <div className="header-right">
                            {isAuthenticated ? (
                                <>
                                    <button className="user-cabinet-button">
                                        <Link to="/ucp">Личный кабинет</Link>
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button
                                        className="user-cabinet-button"
                                        onClick={handleLoginClick}
                                    >
                                        Личный кабинет
                                    </button>
                                </>
                            )}
                            <div className="logo-container">
                                <img
                                    src="/media/logo_medieval.png"
                                    alt="Logo"
                                />
                            </div>
                        </div>
                    </header>
                )}

                <main>{children}</main>
            </div>
            {showFooter && (
                <footer className="footer">
                    <a href="/privacy_policy.pdf" target="_blank" rel="noreferrer">
                        <p>Политика конфиденциальности</p>
                    </a>
                    <p>© 2026. Medieval Role Play. Все права защищены.</p>
                    <p>Пользовательское соглашение</p>
                </footer>
            )}
        </div>
    );
};

export default GuestLayout;
